import { ContainerComponent, wrap } from 'AppReact';
import {
  FlexCenterWrapper, CustomBorderWrapper, Mr2, FullWidthFlexBoxWrapper,
  FullWIdthColumnScrollWrapper, CustomBackgroundWrapper, MaxWidthHeight,
} from 'wrappers';
import { Icon, SecondaryTextXs } from 'atoms';
import Controller from './controller';
import internalState from './internalState';
import { DownCaretSvg } from 'components/icons';
import { SquareCalendarHeaderInputs } from '../customCalendarHeaderInputs';
import Calendar from 'containers/calendar';
import { format, isSameDay } from 'date-fns';
import { SearchTermButton } from 'molecules';

export const definition = {
  name: 'CalendarBoxDropdown',
  controller: Controller,
  initialProps: ({ startDate, endDate, label, icon }) => ({ startDate, endDate, label, icon }),
  props: internalState,
  elements: [
    {
      wrapper: CustomBorderWrapper,
      name: 'Wrapper',
      isButton: true,
      bindings: ({ isOpen, containerRef, inputRef }) => ({ isOpen, containerRef, inputRef }),
      displayState: ({ isOpen }) => ({ hoverColor: `${window.settings?.primary_color ?? '#1DBD6B'}`, borderRadius: '8px', border: isOpen ? `1px solid ${window.settings?.primary_color ?? '#1DBD6B'}` : '1px solid #E3E3E3', background: '#FFFFFF', width: '332px' }),
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          wrapper: CustomBackgroundWrapper,
          name: 'HeaderWrapper',
          renderIf: ({ isOpen }) => !isOpen,
          displayState: ({ startDate, endDate }) => ({ startDate, endDate, alignItems: 'center', justifyContent: 'space-between', padding: startDate || endDate ? '8px' : '12px', background: startDate || endDate ? `${window?.settings?.primary_color ?? '#1DBD6B'}0D` : '' }),
          elements: [
            {
              wrapper: FlexCenterWrapper,
              name: 'LeftSide',
              elements: [
                {
                  component: wrap(Icon, Mr2),
                  name: 'Icon',
                  renderIf: ({ icon }) => !!icon,
                  displayValue: ({ icon }) => icon
                },
                {
                  component: wrap(SecondaryTextXs, Mr2),
                  name: 'Label',
                  renderIf: ({ label }) => !!label,
                  displayValue: ({ label }) => label
                },
                {
                  component: wrap(SearchTermButton, Mr2),
                  name: 'SearchTerm',
                  renderIf: ({ startDate, endDate }) => startDate || endDate,
                  bindings: ({ startDate, endDate }) => ({ text: `${startDate ? format(startDate, 'MM/dd/yyyy') : '/'} - ${endDate ? format(endDate, 'MM/dd/yyyy') : '/'}` })
                },
              ]
            },
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ }) => DownCaretSvg({})
            }
          ]
        },
        {
          wrapper: MaxWidthHeight,
          name: 'BodyWrapper',
          displayState: ({ }) => ({ display: 'flex' }),
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              wrapper: wrap(FullWIdthColumnScrollWrapper, FullWidthFlexBoxWrapper),
              name: 'Body',
              elements: [
                {
                  component: SquareCalendarHeaderInputs,
                  name: 'CustomHeader',
                  bindings: ({ startDate, endDate, isReadonly, editingDate }) => ({ startDate, endDate, isReadonly, editingDate, square: true })
                },
                {
                  component: Calendar,
                  name: 'Calendar',
                  bindings: ({ editingDate, startDate, endDate }) => ({
                    selectedDate: editingDate === 'startDate' ? startDate : endDate,
                    editingDate,
                    hasRemove: true,
                    borderless: true,
                    startDate,
                    endDate,
                    selectedPeriod: !isSameDay(startDate, endDate) ? [startDate, endDate] : null
                  })
                }
              ]
            },
          ]
        },
      ]
    }
  ]
};

export default ContainerComponent(definition);
